// import "../Styles/header.css";
// import { useEffect, useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import { Link } from "react-router-dom";






// const Navbar = () => {
//   const [sticky, setSticky] = useState(false);



//   // nav interactions
//   useEffect(() => {
//     const navMenu = document.getElementById("nav-menu");
//     const navToggle = document.getElementById("nav-toggle");
//     const navClose = document.getElementById("nav-close");
//     const search = document.getElementById("search");
//     const searchBtn = document.getElementById("search-btn");
//     const searchClose = document.getElementById("search-close");

//     if (!navMenu || !navToggle || !navClose || !search || !searchBtn || !searchClose) return;

//     const showMenu = () => navMenu.classList.add("show-menu");
//     const hideMenu = () => navMenu.classList.remove("show-menu");
//     const showSearch = () => search.classList.add("show-search");
//     const hideSearch = () => search.classList.remove("show-search");

//     navToggle.addEventListener("click", showMenu);
//     navClose.addEventListener("click", hideMenu);
//     searchBtn.addEventListener("click", showSearch);
//     searchClose.addEventListener("click", hideSearch);

//     return () => {
//       navToggle.removeEventListener("click", showMenu);
//       navClose.removeEventListener("click", hideMenu);
//       searchBtn.removeEventListener("click", showSearch);
//       searchClose.removeEventListener("click", hideSearch);
//     };
//   }, []);

//   // sticky header
//   useEffect(() => {
//     const onScroll = () => setSticky(window.scrollY > 1);
//     window.addEventListener("scroll", onScroll);
//     return () => window.removeEventListener("scroll", onScroll);
//   }, []);

//   return (
//     <>
//       {/*==================== HEADER ====================*/}
//       <header className={`header ${sticky ? "dark-nav" : ""}`} id="header">
//         <nav className="nav headcontainer">
//           <Link to="/" className="nav__link" style={{ cursor: "pointer", textDecoration: "none" }}>
//             {/* <img
//               src="https://labaib.com/wp-content/uploads/al_opt_content/IMAGE/labaib.com/wp-content/uploads/2024/12/labaib-e1733491787333.png.bv.webp"
//               alt=""
//               className="nav__logo"
//             /> */}
//             PARAMOUNT GREEN SERVICES
//           </Link>

//           <div className="nav__menu" id="nav-menu">
//             <ul className="nav__list">
//               <li className="nav__item"><Link to="/about-us/" className="nav__link" style={{ cursor: 'pointer', textDecoration: 'none' }}>About Us</Link></li>
//               <li className="nav__item"><Link to="/faq/" className="nav__link" style={{ cursor: 'pointer', textDecoration: 'none' }}>Faq's</Link></li>
//               <li className="nav__item"><Link to="/Ourteam/" className="nav__link" style={{ cursor: 'pointer', textDecoration: 'none' }}>Our Team</Link></li>
//               {/* <li className="nav__item">
//                 <Link to="/Registration" className="nav__link glow-button" style={{ cursor: 'pointer', textDecoration: 'none' }}>Register Here</Link>
//               </li> */}
//               <li className="nav__item dropdown">
//                 <span className="nav__link dropdown-toggle">More</span>
//                 <ul className="dropdown-menu">
//                   <li><Link to="/Why-Choose-Us" className="dropdown-item">Why Choose Us</Link></li>
//                   <li><Link to="/careers/" className="dropdown-item">Careers</Link></li>
//                   <li><Link to="/Contactus" className="dropdown-item">Contact Us</Link></li>
//                 </ul>
//               </li>
//             </ul>

//             <div className="nav__close" id="nav-close">
//               <i className="ri-close-line"></i>
//             </div>
//           </div>

//           <div className="nav__actions" style={{ paddingBottom: "20px" }}>
//             <i className="ri-account-box-fill nav__search" id="search-btn"></i>
//             <div className="nav__toggle" id="nav-toggle">
//               <i className="ri-menu-line"></i>
//             </div>
//           </div>
//         </nav>
//       </header>
//     </>
//   );
// };

// export default Navbar;
import React,{useState} from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "../Styles/header.css";



const Navbar = () => {
  // State to track toggler open/close
  const [isOpen, setIsOpen] = useState(false);

  // Toggle handler
  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  // Close menu on link click (for better UX)
  const closeNavbar = () => {
    setIsOpen(false);
  };

  return (
    <nav className="navbar navbar-expand-lg fixed-top custom-navbar shadow-sm">
      <div className="container d-flex justify-content-between align-items-center">
        {/* Left - Logo */}
        <Link className="navbar-brand fw-bold logo-text" to="/">
          <span className="d-none d-sm-inline">PARAMOUNT GREEN SERVICES</span>
          <span className="d-inline d-sm-none text-white">PGS</span>
        </Link>

        {/* Toggler (always visible on medium and below) */}
        <button
          className="navbar-toggler ms-2"
          type="button"
          aria-controls="navbarNavDropdown"
          aria-expanded={isOpen}
          aria-label="Toggle navigation"
          onClick={toggleNavbar}
        >
          <span className="navbar-toggler-icon">
            {/* Custom icon switching */}
            {isOpen ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                className="bi bi-x-lg"
                viewBox="0 0 16 16"
              >
                <path d="M2.146 2.146a.5.5 0 0 1 .708 0L8 7.293l5.146-5.147a.5.5 0 0 1 
                .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 
                5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854a.5.5 0 0 1 0-.708z" />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                className="bi bi-list"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M2.5 12.5a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-11zm0-4a.5.5 0 0 1 0-1h11a.5.5 0 0 1 
                  0 1h-11zm0-4a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-11z"
                />
              </svg>
            )}
          </span>
        </button>

        {/* Middle - Nav links + "Get in touch" inside collapse */}
        <div
          className={`collapse navbar-collapse justify-content-center ${isOpen ? "show" : ""}`}
          id="navbarNavDropdown"
        >
          <ul className="navbar-nav">
            <li className="nav-item mx-2">
              <Link className="nav-link" to="/about-us/" onClick={closeNavbar}>
                About Us
              </Link>
            </li>
            <li className="nav-item mx-2">
              <Link className="nav-link" to="/faq" onClick={closeNavbar}>
                FAQ
              </Link>
            </li>
            <li className="nav-item mx-2">
              <Link className="nav-link" to="/Ourteam" onClick={closeNavbar}>
                Our Team
              </Link>
            </li>
            <li className="nav-item mx-2">
              <Link className="nav-link" to="/careers/" onClick={closeNavbar}>
                Careers
              </Link>
            </li>
            <li className="nav-item mx-2">
              <Link className="nav-link" to="/Why-Choose-Us" onClick={closeNavbar}>
                Why Choose Us
              </Link>
            </li>
            {/* Get in touch only visible inside collapse on medium and below */}
            <li className="nav-item mx-2 d-lg-none mt-2">
              <Link
                className="btn btn-outline-primary rounded-pill get-in-touch-btn w-100"
                to="/Contactus"
                onClick={closeNavbar}
              >
                Get in touch
              </Link>
            </li>
          </ul>
        </div>

        {/* Right - Get in touch on large screens */}
        <div className="d-none d-lg-flex">
          <Link className="btn btn-outline-primary rounded-pill get-in-touch-btn" to="/Contactus">
            Get in touch
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;



